<template>
  <qx-card title="异常登记">
    <section slot="titleRight">
      <qx-permpisions permpisions="3303221" v-show="$route.query.showBaseInfo">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'problemPrice'">
                {{ (scope.row[scope.column.property] / 100).toFixed(2) }}
              </section>
              <section v-else-if="scope.column.property === 'problemDealPrice'">
                {{ (scope.row[scope.column.property] / 100).toFixed(2) }}
              </section>
              <section v-else>{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="180"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :isCenter="true"
                :btnList="[
                  {
                    permpisions: '3303223',
                    showCondition:
                      (scope.row.state === 0 || scope.row.state === 1) && scope.row.isJurisdiction == true,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  {
                    permpisions: '3303222',
                    showCondition: scope.row.state === 0,
                    name: '修改',
                    event: () => toEdit(scope.row.problemId),
                  },
                  {
                    permpisions: '3303224',
                    showCondition: scope.row.state === 0,
                    name: '取消',
                    event: () => cancel(scope.row.problemId),
                  },
                  {
                    name: '查看',
                    event: () => toDetail(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  orderUnusualRegisterList,
  orderUnusualRegisterDel,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
  },
  data () {
    return {
      searchBoxData: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'createDate',
            label: '创建时间',
          },
          {
            prop: 'responsiblePartyName',
            label: '业务方',
          },
          {
            prop: 'problemTypeName',
            label: '异常类型',
          },
          {
            prop: 'problemPrice',
            label: '登记金额(元)',
          },
          {
            prop: 'problemDealPrice',
            label: '处理金额(元)',
          },
          {
            prop: 'problemDesc',
            label: '异常描述',
          },
          {
            prop: 'carOwnerName',
            label: '责任司机',
          },
          {
            prop: 'sourceProblemName',
            label: '异常来源',
          },
          {
            prop: 'stateName',
            label: '内部审核',
          },
          {
            prop: 'problemExternalStateName',
            label: '对方审核',
          },
          {
            prop: 'verifyDate',
            label: '处理时间',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orderUnusualRegisterList,
    handleBeforeGetData () {
      this.searchBoxData = {
        orderId: this.$route.query.id,
        selectType: 1,
      };
    },
    toEdit (id) {
      this.jump({
        label: id ? '修改异常登记' : '新增异常登记',
        url: `/manage/operate/order/deal/orderDetailTab/unusual/edit?orderId=${this.$route.query.id}${id ? '&id=' + id : ''}`,
        full: true,
      });
    },
    async cancel (problemId) {
      const confirmRes = await this.$confirm('是否确认取消该异常？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await orderUnusualRegisterDel({
          problemId,
        });
        if (!res.failed) {
          this.$message.success('取消成功');
          this.getData();
        }
      }
    },
    toDetail (item, type = '') {
      let label = '审核异常登记详情';
      if (type === 'apply') {
        label = '审核异常登记申诉';
      } else if (type === 'approve') {
        label = '审核异常登记审核';
      }
      this.jump({
        label,
        url: `/manage/operate/order/deal/orderDetailTab/unusual/detail?orderId=${this.$route.query.id}&id=${item.problemId}&type=${type}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
